import {css} from "lit-element/lit-element.js";
export default css`
.image-prompt {
  display: flex;
  gap: 1.5em;
  align-items: flex-start;
  margin-top: 2rem;
}
@media only screen and (max-device-width: 800px) and (orientation: portrait) {
  .image-prompt {
    align-items: center;
    flex-direction: column;
    gap: 0;
    margin-bottom: 5rem;
  }
}
.image-prompt .left {
  display: flex;
  flex-direction: column;
}
.image-prompt .left .wrapper {
  position: relative;
}
.image-prompt .left .wrapper .src {
  position: absolute;
  right: 2rem;
  bottom: 2rem;
  color: white;
  font-size: 1.5rem;
  text-shadow: 2px 2px black;
  text-decoration: none;
}
.image-prompt .left .animation {
  position: relative;
  width: 224px;
  height: 15px;
  opacity: 0;
}
.image-prompt .left .animation .computing {
  text-align: center;
}
.image-prompt .right {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 0.5em;
}
.image-prompt .right .top {
  text-align: right;
  height: 30px;
}
.image-prompt .right .buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 1em;
  align-items: center;
}
.image-prompt .right .item {
  position: relative;
  display: flex;
}
.image-prompt .right .item .pct {
  display: inline-block;
  margin-right: 1em;
  width: 3.5em;
  text-align: right;
  opacity: 0;
  transition: opacity 0.5s;
}
.image-prompt .right .item input {
  flex-grow: 1;
  max-width: 70vw;
  border-radius: 0;
  background: transparent;
  border: 0;
  border-bottom: 1px solid var(--text-fg);
  color: var(--text-fg);
  outline: none;
}
.image-prompt .right .item input.toolong {
  border-bottom: 1px solid var(--text-red);
  color: var(--text-red);
}
.image-prompt .right .item .bar {
  position: absolute;
  display: inline-block;
  top: 5%;
  left: 0;
  z-index: -1;
  background: var(--bar-col);
  height: 90%;
  width: 0;
  transition: width 0.5s;
}
.image-prompt .right .bottom {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 1em;
  align-items: center;
  opacity: 0;
}
.image-prompt .right .bottom .tweet {
  background: rgb(18, 150, 223);
  color: white;
  text-decoration: none;
  padding: 0px 15px;
  border-radius: 16px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
